<template>
  <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="products.isLoading">
    <el-row type="flex" justify="space-between" align="middle" class="mb-4">
      <p class="category-title ma-0">Product</p>
      <el-col :span="16">
        <el-row type="flex" justify="end">
          <el-select
            v-model="optionView"
            size="small"
            placeholder="Select"
            @change="
              e => {
                toAnotherPage(page, e, form.search), settingTable(page, e);
              }
            "
            class="mr-2"
            style="width: 100px"
          >
            <el-option
              v-for="item in optionsView"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            size="small"
            v-model="form.search"
            placeholder="Search by name or id"
            style="width: 200px"
            class="mr-2"
            @keyup.enter.native="onSearch"
          ></el-input>

          <el-button type="primary" @click="onSearch" size="small">Search</el-button>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-table empty-text="Tidak ada data" :data="products.data" style="width: 100%">
        <el-table-column sortable prop="oracleItemId" label="Oracle Item ID" width="180"></el-table-column>
        <el-table-column sortable prop="oracleItemCode" label="Oracle Item Code" width="180"></el-table-column>
        <el-table-column sortable prop="itemName" label="Item Name" width="380">
          <template slot-scope="scope">
            <span class="truncate-text">{{ scope.row.itemName }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="description" label="Description" width="380">
          <template slot-scope="scope">
            <span class="truncate-text">{{ scope.row.description }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="itemType" label="Type" width="180"></el-table-column>
        <el-table-column sortable prop="isActive" label="Active" width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.isActive"
              placeholder="Select"
              @change="(e) => handleUpdate(e, scope.row.itemCode)"
            >
              <el-option
                v-for="item in optionsActive"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="180" fixed="right" label="Operations">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-edit"
              circle
              @click="$router.push(`/product/edit/${scope.row.oracleItemId}`)"
            ></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" circle></el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :total="products.count"
          :current-page="parseInt(page)"
          @current-change="
            e => {
              toAnotherPage(e, optionView, form.search), settingTable(e, optionView);
            }
          "
          :page-size="parseInt(optionView)"
        ></el-pagination>
      </el-row>
    </el-col>
    <router-view></router-view>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatPrice } from "../../common/currency";
export default {
  name: "product-list",
  data() {
    return {
      modeEdit: false,
      form: {
        search: ""
      },
      optionsActive: [
        {
          value: true,
          label: "Active"
        },
        {
          value: false,
          label: "No Active"
        }
      ],
      dialog: false,
      id: null,
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      page: 1
    };
  },
  mounted() {
    this.$ga.page('/product');
  },
  methods: {
    ...mapActions({
      getProducts: "product/GetProducts",
      deleteProduct: "product/DeleteProduct",
      updateStatusProduct: "product/UpdateStatusProduct"
    }),
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    handleUpdate(value, idx) {
      const body = {
        id: idx,
        isActive: value
      }
      this.updateStatusProduct(body)
    },
    toAnotherPage(page, limit, search) {
      this.$router.push({
        path: "/product",
        query: { page: page, limit: limit, search: search }
      });
    },
    onSearch() {
      this.$router.replace({ path: "/product", query: { page: 1, limit: 25 } });
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getProducts(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      this.form.search = this.$router.history.current.query.search;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getProducts(option);
    },
    callFormatPrice(value) {
      return formatPrice(value);
    },
    setModeEdit() {
      this.modeEdit = true;
    }
  },
  computed: {
    ...mapState({
      products: state => state.product.products
    })
  },
  watch: {
    product: {
      handler(newValue) {
        if (!newValue.isLoading && !newValue.error) {
          this.dialog = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    this.form.search = this.$router.history.current.query.search || '';
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
        search: this.form.search
      }
    };
    this.getProducts(option);
  }
};
</script>

<style>
.custom-container {
  padding-top: 0px !important;
}
.custom-table thead {
  background-color: #dee2e6;
}
.custom-table thead tr th {
  font-weight: bold;
}
.custom-table tbody {
  background-color: #f8f9fa;
}
.truncate-text {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
